import API_URL, { isNew } from "@/common/config"
import { Notify } from "@/components"
import router from "@/router"
import { useAppStore } from "@/store"
import { Desensitization } from "@dg/utils"
import dayjs from "dayjs"
import { saveAs } from "file-saver"
import { cloneDeep } from "lodash"
import { closeToast, showImagePreview, showLoadingToast } from "vant"
import showActionSheet from "@/components/Base/ActionSheet/showActionSheet.js"
import { isZWEnv, ZWApis } from "./ZWApi"

export const extend = Object.assign

export const getInfoFromIDCard = (idCard, type = "age") => {
  if (type === "age") {
    const myDate = new Date()
    const month = myDate.getMonth() + 1
    const day = myDate.getDate()
    let age = myDate.getFullYear() - idCard.substring(6, 10) - 1
    if (
      idCard.substring(10, 12) < month ||
      (idCard.substring(10, 12) == month && idCard.substring(12, 14) <= day)
    ) {
      age++
    }
    return age
  } else if (type === "birthday") {
    let birthday =
      idCard.substring(6, 10) +
      "-" +
      idCard.substring(10, 12) +
      "-" +
      idCard.substring(12, 14)
    return birthday
  } else if (type === "sex") {
    let num = idCard.charAt(idCard.length - 2)
    if (num % 2 == 0) {
      return "女"
    } else {
      return "男"
    }
  }
}

export const groupObjectArrayByKey = (array, key) => {
  array = cloneDeep(array)
  return array.reduce((rv, x) => {
    ;(rv[x[key]] = rv[x[key]] || []).push(x)
    return rv
  }, {})
}

/**
 *
 * @param {*} obj
 * @returns  arr
 */
export const orderObjectToArray = (obj) => {
  const keys = Object.keys(obj)
  const len = keys.length
  const arr = Array(len)
  keys.forEach((key) => {
    arr[obj[key]] = key
  })
  return arr
}

/**
 * 获取指定范围内的数字列表
 * @param {Number} start 起始值
 * @param {Number} end 结束值
 * @param {Number} step 步长
 * @return {Array} 数字列表
 * @example
 * getRangeList(1, 10, 2) // [1, 3, 5, 7, 9]
 * getRangeList(1, 10, 3) // [1, 4, 7, 10]
 * getRangeList(1, 10, 5) // [1, 6, 11]
 * getRangeList(1, 10, 10) // [1, 10]
 *
 **/
export const getRangeList = (start, end, step) => {
  const list = []
  for (let i = start; i <= end; i += step) {
    list.push(i)
  }
  return list
}

// 身份证脱敏

/**
 * @param {String} idCard 身份证号
 * @return {String} 脱敏后的身份证号
 * @example
 * idCardDesensitization('420102199003027077') // '420102****27077'
 *
 **/

export const idCardDesensitization = (idCard) => {
  const idCardLen = idCard.length
  const idCardDesensitization =
    idCard.substring(0, 6) + "****" + idCard.substring(idCardLen - 4, idCardLen)
  return [idCardDesensitization, idCard]
}

// 姓名脱敏
export const nameDesensitization = (name) => {
  const nameLen = name.length
  const nameDesensitization =
    name.substring(0, 1) + "*" + name.substring(nameLen - 1, nameLen)
  return [nameDesensitization, name]
}

// 电话脱敏
export const telephoneDesensitization = (telephone) => {
  const len = telephone.length
  const telephoneDesensitization = "****" + telephone.substring(len - 4, len)
  return [telephoneDesensitization, telephone]
}

/**
 *
 * @param {*} start
 * @returns
 * @example
 *
 */
export const getYearRangeToNow = (start) => {
  const end = new Date().getFullYear()
  const list = []
  for (let i = start; i <= end; i++) {
    list.push(i)
  }
  return list.reverse()
}

export function validPhone(phone) {
  const reg = new RegExp(/^1[3-9]\d{9}$/)
  return reg.test(phone)
}

/** 座机校验 */
export function validLangLine(value) {
  // 是否存在区号
  const hadCode = value.split("-").length === 2
  const reg = hadCode ? /^0\d{2,4}-\d{7,8}$/ : /^\d{7,8}$/
  return reg.test(value)
}

export function validCardNum(value) {
  if (!value) return [false, "不能为空"]

  const patter =
    /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0-9]{3})([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/

  // 判断格式是否正确
  const format = patter.test(value)
  if (!format) return [false, "格式错误"]
  // 加权因子
  const weight_factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
  // 校验码
  const check_code = ["1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2"]
  const last = value[17] //最后一位
  const seventeen = value.substring(0, 17)
  // ISO 7064:1983.MOD 11-2
  // 判断最后一位校验码是否正确
  const arr = seventeen.split("")
  const len = arr.length
  let num = 0
  for (let i = 0; i < len; i++) num += arr[i] * weight_factor[i]
  // 获取余数
  const resisue = num % 11
  const last_no = check_code[resisue]
  // 返回验证结果，校验码和格式同时正确才算是合法的身份证号码
  const result = last === last_no ? true : false
  return [result, "格式错误"]
}

//表单验证
export function validate(rules, formData) {
  const form = formData
  return new Promise((resolve, reject) => {
    let errors = []
    Object.keys(rules).forEach((key) => {
      const rule = rules[key]
      for (let i = 0; i < rule.length; i++) {
        const validItem = rule[i]
        if (validItem.required) {
          if (validItem.type === "array" && form[key].length == 0) {
            errors.push({ name: key, message: validItem.message })
            break
          } else if (
            form[key] === undefined ||
            form[key] === null ||
            form[key] === ""
          ) {
            errors.push({ name: key, message: validItem.message })
            break
          }
        }
        if (validItem.validator) {
          if (!validItem.validator(form[key])) {
            errors.push({ name: key, message: validItem.message })
          }
        }
      }
    })
    if (errors.length) {
      reject(errors)
    }
    resolve()
  })
}

//
export function formatChatTime(timestamp) {
  const now = dayjs()
  const thisYear = now.format("YYYY")
  const dateTime = dayjs(timestamp)

  // 如果是当天消息，则只显示具体的时分
  if (now.isSame(dateTime, "day")) {
    return dateTime.format("HH:mm")
  }

  // 如果是昨天
  if (now.subtract(1, "day").isSame(dateTime, "day")) {
    return `昨天 ${dateTime.format("HH:mm")}`
  }

  // 如果是今年内的其他日期，只显示月日和时间
  if (dateTime.format("YYYY") === thisYear) {
    return dateTime.format("MM-DD HH:mm")
  }

  // 跨年的，显示完整时间格式
  return dateTime.format("YYYY-MM-DD HH:mm")
}

export function toLogin() {
  toLogout()
  const LoginFn = useZlbLogin()
  if (isNew) {
    showActionSheet({
      title: "登录",
      message: "这是一个消息提示",
      actions: [
        { name: "个人登录", value: 1 },
        { name: "法人登录", value: 2 },
        { name: "绿色通道", value: 3 }
      ],
      cancelText: "取消",
      onSelect: (item) => {
        switch (item.value) {
          case 1:
            LoginFn.person()
            break
          case 2:
            LoginFn.legal()
            break
          case 3:
            LoginFn.green()
            break
        }
      }
    })
  } else {
    const goto = encodeURIComponent(window.location)
    const env = process.env.NODE_ENV
    const proIp = `${process.env.VUE_APP_PY_UTL}/talent_mobile/`
    const devIp = `${process.env.VUE_APP_PY_UTL}/talent_mobile/`
    const ip = env === "production" ? proIp : devIp
    window.location.href = `${ip}talent_mobile/refact-login?goto=${encodeURIComponent(
      goto
    )}`
  }
}

// 1. 法人登录
export const LegalURL = `https://portal.zjzwfw.gov.cn/uc/sso/login?appId=OPGTzv7zE1k9UEILanlHkl6Bb101&userType=legal&sp=`
// 2. 个人登录
export const PersonURL = `https://portal.zjzwfw.gov.cn/uc/sso/login?appId=OPGTzv7zE1k9UEILanlHkl6Bb101&userType=person&sp=`
// 浙里办登录
export function useZlbLogin(goto) {
  const href = encodeURIComponent(goto ?? location.href)

  let loginSp = encodeURIComponent(
    `https://rc-zzb.wenzhou.gov.cn:65443/rencai/api/dg_pubuser/auth/zlb/rc?sp=${href}`
  )

  return {
    legal: () => {
      window.location.href = LegalURL + loginSp
    },
    person: () => {
      window.location.href = PersonURL + loginSp
    },
    green: () => {
      router.push("/green-login")
    }
  }
}

export const toLogout = () => {
  const appStore = useAppStore()
  appStore.logout()
}

// 预览 hooks
export function previewImgList(images, index = 0) {
  showImagePreview({
    images,
    startPosition: index
  })
}

// 下载 hooks
export function downloadFile(config) {
  if (isZWEnv()) {
    showLoadingToast()
    const url = `${API_URL}commonzlb/zlb_pub_download/${encodeURIComponent(
      config.name
    )}/?id=${config.uuid}`
    ZWApis({
      action: "downloadFile",
      data: { url }
    })
      .finally(() => {
        closeToast()
      })
      .catch((err) => {
        Notify.error("保存失败")
      })
  } else {
    saveAs(config.path, config.name)
  }
}

//脱敏
export const encryp = function (value, type) {
  if (value) {
    let len = value.length
    switch (type) {
      case "name":
        return Desensitization["cnName"](value).target
      case "phone":
        return Desensitization["phone"]["phone"](value).target
      case "idCard":
        return certDesensitization(value).target
      case "telephone":
        return "****" + value.substring(len - 4, len)
    }
  }
  return value
}

export const isIos = function () {
  return window.navigator.userAgent.match(/(iPhone|iPad|iPod|ios)/i)
}

// 身份证号、护照等多种证件号脱敏
export function certDesensitization(idCard) {
  const firstNum = idCard[0]
  const lastNum = idCard[idCard.length - 1]
  let target = [firstNum, lastNum].join("*")
  if (idCard.length > 2) {
    target = [firstNum, lastNum].join("*".repeat(idCard.length - 2))
  }
  return {
    source: idCard,
    target
  }
}
